import React from 'react';

const Favorite = ({ scheduleChanger, config, scheduleItem }) => {
  const [favoriteApi, ] = React.useState(config.favorite_api);
  const [favoriteState, setFavoriteState] = React.useState(scheduleItem.is_favorite);
  const params = new URLSearchParams(window.location.search)

  const toggleFavoriteClick = (e, favorite_state) => {
    $.ajax({
      url: favoriteApi,
      type: 'POST',
      data: {
        oid: params.get("oid"),
        rt: params.get("rt"),
        aid: scheduleItem.attendee_id,
        lid: scheduleItem.line_item_id,
        sid: scheduleItem.id,
        state: favorite_state ? 1 : 0
      },
      success: function() {
        scheduleItem.is_favorite = favorite_state
        scheduleChanger()
        setFavoriteState(favorite_state)
      }
    });
  };

  return (
    <a style={{ float: 'right' }} onClick={(e) => toggleFavoriteClick(e, !favoriteState)}>
      <i style={{opacity: `${favoriteState ? 1 : 0.4}`}} className={`${favoriteState ? 'fas red' : 'fas text-muted'} fa-heart`}/>
    </a>
  );
};

export default Favorite;
